module.exports = __webpack_public_path__ + "img/envirofit-bg@2x.24577658.png";